<!-- 商品分类 -->

<template>
  <div class="pcOrder">
    <p style="margin-top: 10px; color: red" class="clearfix">
      <!-- <el-button style="float:right" type="primary" @click.stop="save">保存</el-button> -->
    </p>
    <div class="select-wrap" style="width: 100%">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
      </el-form>
    </div>
    <div class="goods-cont">
      <!-- <p class="tit" style="padding-bottom:10px;"><i></i>
          <el-button type="primary" @click.stop="save">保存</el-button>
        </p> -->
      <div class="goods-left">
        <div class="filter">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="选择分类">
              <el-select v-model="typeId" placeholder="活动区域">
                <el-option key="" label="全部" value=""></el-option>
                <el-option
                  v-for="item in systemData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
                <el-option
                  v-for="item in typeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="warning" @click="getGoods">查询</el-button>
            </el-form-item>
          </el-form>
          <div>
            <el-button type="primary" @click="save">保存</el-button>
          </div>
        </div>

        <el-table
          ref="multipleTable"
          :data="tableData"
          :row-key="getRowKeys"
          @selection-change="handleSelectionChange"
          tooltip-effect="dark"
        >
          <el-table-column
            type="selection"
            width="65"
            :reserve-selection="true"
          ></el-table-column>
          <el-table-column label="商品名">
            <template slot-scope="scope">{{ scope.row.productName }}</template>
          </el-table-column>
          <el-table-column prop="typeName" label="分类"></el-table-column>
          <el-table-column
            prop="price"
            label="价格"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </div>
      <!-- <div class="goods-right">
        <p class="tit" style="padding-bottom:10px;">套餐选择
        </p>
        <el-table
          ref="multipleTableForMeals"
          :data="tableDataForMeals"
          :row-key="getRowKeys"
          @selection-change="handleSelectionChangeForMeal"
          tooltip-effect="dark"
        >
          <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
          <el-table-column label="商品名" width="240">
            <template slot-scope="scope">{{ scope.row.productName }}</template>
          </el-table-column>
          <el-table-column prop="typeName" label="分类" width="240"></el-table-column>
          <el-table-column prop="price" label="价格" show-overflow-tooltip></el-table-column>
        </el-table>
      </div> -->
    </div>
  </div>
</template>

<script type="text/javascript">
import { url } from "@/router/url.js";
import { BASE_URL } from "../../../urlConfig";
export default {
  name: "labelPrint",
  props: ["curStoreId"],
  data() {
    return {
      allProductIds: [],
      typeId: "",
      systemData: [],
      typeList: [],
      tableDataForMeals: [],
      nowPage: 1,
      setMealIds: [],
      size: 1000,
      searchVal: "",
      curSelType: null,
      formInline: {
        user: "",
        region: "",
      },
      labelPosition: "right",
      newDiscount: {
        name: "",
        region: "",
        type: "",
        week: [],
        nowHours: "",
        tomorrowHour: "",
        discountMethod: "",
      },
      options: [],
      modifyDiscountItem: {},
      tableData: [],
      types: [],
      nowSelClassGoods: [],
      multipleSelection: [],
      multipleSelectionForMeal: [],
      totalPage: 0,
      totalElements: 0,
    };
  },
  methods: {
    getRowKeys(row) {
      return row.productId;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
    },
    handleSelectionChangeForMeal(val) {
      this.multipleSelectionForMeal = val;
      console.log(val);
    },
    // 新增优惠方式
    save() {
      let productIds = [];
      let notCatchGoodsIds = [];
      let setMealIds = [];
      for (let j = 0; j < this.multipleSelection.length; j++) {
        productIds.push(this.multipleSelection[j].productId);
      }
      for (let i = 0; i < this.multipleSelectionForMeal.length; i++) {
        setMealIds.push(this.multipleSelectionForMeal[i].productId);
      }
      // console.log("seled", this.multipleSelection);
      // let labels = [];
      // for (let i = 0; i < this.tableData.length; i++) {
      //   let obj = {
      //     labelEnabled:false,
      //     productId:this.tableData[i].productId
      //   }
      //   for(let j=0;j<this.multipleSelection.length;j++){
      //     if(this.multipleSelection[j].productId == this.tableData[i].productId){
      //       obj.labelEnabled = true;
      //     }
      //   }
      //   labels.push(obj);
      // }

      if (
        this.allProductIds &&
        Array.isArray(this.allProductIds) &&
        this.allProductIds.length
      ) {
        if (productIds && Array.isArray(productIds)) {
          this.allProductIds.forEach((it) => {
            if (productIds.indexOf(it) == -1) {
              notCatchGoodsIds.push(it);
            }
          });
        }
      }
      this.$http({
        url: "capture",
        method: "POST",
        data: {
          productIds,
          capture: true,
          // storeId: this.curStoreId,
        },
      }).then((res) => {
        this.$message({
          message: "操作成功",
          customClass: "success",
        });
      });
      this.$http({
        url: "capture",
        method: "POST",
        data: {
          productIds: notCatchGoodsIds,
          capture: false,
          // storeId: this.curStoreId,
        },
      }).then((res) => {});
    },
    // 获取商品
    getGoods(page) {
      this.$http({
        url: "/products",
        method: "GET",
        params: {
          storeId: this.curStoreId,
          isStock: -1,
          kitchen: -1,
          typeId: this.typeId,
          // page,
          // size: this.size,
          // typeId:1,
        },
      }).then((res) => {
        let goodsList = res.data;
        let newGoodsData = [];
        if (
          !this.allProductIds ||
          !Array.isArray(this.allProductIds) ||
          !this.allProductIds.length
        ) {
          let allProductIds = [];
          for (let i = 0; i < goodsList.length; i++) {
            goodsList[i].count = 0;
            allProductIds.push(goodsList[i].id);
            goodsList[i].isChecked = goodsList[i].capture;

            if (goodsList[i].setMealEnabled) {
              goodsList[i].productId = goodsList[i].setMealId;
            }
          }
          this.allProductIds = allProductIds;
        }

        for (let j = 0; j < goodsList.length; j++) {
          let obj = {
            price: goodsList[j].salesPrice,
            productId: goodsList[j].id,
            productName: goodsList[j].name,
            setMealEnabled: goodsList[j].setMealEnabled,
            setMealId: goodsList[j].setMealId,
            typeId: goodsList[j].typeId,
            typeName: goodsList[j].typeName,
            isChecked: goodsList[j].isChecked,
          };
          newGoodsData.push(obj);
        }
        let arr = [];
        for (let i = 0; i < newGoodsData.length; i++) {
          if (newGoodsData[i].isChecked) {
            arr.push(newGoodsData[i]);
          }
        }
        arr.forEach((item) => {
          this.$refs.multipleTable.toggleRowSelection(item, true);
        });
        // this.goodsList = goodsList;
        this.tableData = newGoodsData;
        this.totalPage = res.data.totalPage;
        this.totalElements = res.data.totalElements;
        this.canChangePage = true;
      });
    },
    getMeals(typeId) {
      return new Promise((resolve, reject) => {
        this.$http({
          url: "/meal/get-all-ps",
          method: "GET",
          params: {
            storeId: this.curStoreId,
            page: 0,
            size: this.size,
            typeId,
          },
        }).then((res) => {
          let goodsList = res.data.data;
          let newGoodsData = [];
          for (let i = 0; i < goodsList.length; i++) {
            goodsList[i].count = 0;
            goodsList[i].isChecked = goodsList[i].wechatEnabled;
            if (goodsList[i].setMealEnabled) {
              goodsList[i].productId = goodsList[i].setMealId;
            }
          }
          for (let j = 0; j < goodsList.length; j++) {
            let obj = {
              price: goodsList[j].price,
              productId: goodsList[j].productId,
              productName: goodsList[j].productName,
              setMealEnabled: goodsList[j].setMealEnabled,
              setMealId: goodsList[j].setMealId,
              typeId: goodsList[j].typeId,
              typeName: goodsList[j].typeName,
              isChecked: goodsList[j].isChecked,
            };
            newGoodsData.push(obj);
          }
          resolve(newGoodsData);
          this.tableDataForMeals = newGoodsData;
        });
      });
    },
    getType() {
      this.$http({
        url: "product-types",
        method: "GET",
        params: {
          storeId: this.curStoreId,
        },
      }).then(async (res) => {
        let typeList = [];
        let systemData = [];
        if (res.data && res.data.data && Array.isArray(res.data.data)) {
          typeList = res.data.data;
        }
        if (
          res.data &&
          res.data.systemData &&
          Array.isArray(res.data.systemData)
        ) {
          systemData = res.data.systemData;
        }
        this.typeList = typeList;
        this.systemData = systemData;
        // let funArr = [];
        // for (let i = 0; i < res.data.length; i++) {
        //   if (res.data[i].setMealEnabled) {
        //     let fun = this.getMeals(res.data[i].id);
        //     funArr.push(fun);
        //   }
        // }
        // Promise.all(funArr)
        //   .then((res) => {
        //     console.log(res);
        //     let mealsArr = [];
        //     for (let i = 0; i < res.length; i++) {
        //       mealsArr = mealsArr.concat(res[i]);
        //     }
        //     console.log(mealsArr);

        //     let arr = [];
        //     for (let i = 0; i < mealsArr.length; i++) {
        //       if(mealsArr[i].isChecked){
        //         arr.push(mealsArr[i]);
        //       }
        //     }
        //     arr.forEach((item) => {
        //       this.$refs.multipleTableForMeals.toggleRowSelection(item, true);
        //     });

        //     this.tableDataForMeals = mealsArr;
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });
      });
    },
  },
  async activated() {
    this.getGoods(0);
    await this.getType();
  },
};
</script>
<style lang="scss" scoped>
@import "./catchRateGoods.scss";
</style>



// WEBPACK FOOTER //
// catchRateGoods.vue?4e10dde7